import PropTypes from 'prop-types';
// main.js
import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import moment from "moment";
import cx from "classnames";
import access from "safe-access";

var paramsTransformer = {
    event: function (event) {
        let params = _.pick(event, 'eventId', 'startDate', 'homeId', 'awayId', 'homeShortName', 'awayShortName', 'tournamentName', 'tournamentId');
        params.date = params.startDate && moment(params.startDate).format("DD-MM-YYYY");
        params.tournamentId = event.tournamentTemplateId;
        for (let i in params) params[i] = encodeURIComponent(params[i]);
        return params;
    }
}

class Link extends React.Component {

   constructor(props) {
       super(props);
   }

   handleVoid(e) {
       e.stopPropagation();
       e.preventDefault();
       return false;
   }

   render() {
       let {action, withParams, disabled} = this.props;
       let href = null;
       if (action && this.context.deeplinker && !disabled) {
            let params = paramsTransformer[action] && paramsTransformer[action](withParams) || withParams;
            href = this.context.deeplinker.resolve(action, params);
       } else {
           // other ways of delivering
       }

       return (<a className={cx("wdp-link", this.props.className, {'wdp-link-inactive': !href})} href={href} onClick={!href && this.handleVoid}>{this.props.children}</a>)
   }
}

Link.contextTypes = {
    info: PropTypes.object,
    deeplinker: PropTypes.object
};

export default Link;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/Link.js
 **/